"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeValues = mergeValues;
function mergeValues(existing, incoming, merge) {
    if (incoming === undefined) {
        return existing;
    }
    if (merge) {
        return merge(existing, incoming);
    }
    else {
        return incoming;
    }
}
//# sourceMappingURL=merge-values.js.map